
// ===========================
// CART STATE
// ===========================
const cart = {};

function showToast(msg) {
  const toast = document.getElementById('toast');
  toast.textContent = msg;
  toast.classList.add('visible');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => toast.classList.remove('visible'), 3200);
}

function updateCartUI() {
  const total = Object.values(cart).reduce((s, i) => s + i.qty, 0);
  const totalPrice = Object.values(cart).reduce((s, i) => s + i.price * i.qty, 0);

  const badge = document.getElementById('cart-badge');
  badge.textContent = total;
  badge.classList.toggle('visible', total > 0);

  document.getElementById('cart-count-text').textContent = `(${total})`;
  document.getElementById('cart-total-amount').textContent = `€${totalPrice.toFixed(2)}`;

  const listEl = document.getElementById('cart-items-list');
  const emptyEl = document.getElementById('cart-empty');
  const footerEl = document.getElementById('cart-footer');

  if (total === 0) {
    emptyEl.style.display = '';
    footerEl.style.display = 'none';
    listEl.innerHTML = '';
    listEl.appendChild(emptyEl);
    return;
  }

  emptyEl.style.display = 'none';
  footerEl.style.display = '';

  listEl.innerHTML = '';
  Object.values(cart).forEach(item => {
    const div = document.createElement('div');
    div.className = 'cart-item';
    div.innerHTML = `
      <div class="cart-item-img">${item.emoji || '🛍️'}</div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.name}</div>
        <div class="cart-item-price">€${(item.price * item.qty).toFixed(2)}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" onclick="changeQty(${item.id}, -1)">−</button>
          <span class="qty-display">${item.qty}</span>
          <button class="qty-btn" onclick="changeQty(${item.id}, 1)">+</button>
        </div>
      </div>
      <button class="cart-item-remove" onclick="removeItem(${item.id})">×</button>
    `;
    listEl.appendChild(div);
  });
}

function addToCart(id, name, price, emoji) {
  if (cart[id]) {
    cart[id].qty++;
  } else {
    cart[id] = { id, name, price: parseFloat(price), qty: 1, emoji };
  }
  updateCartUI();
  showToast(`🛍️ ${name} añadido al carrito`);
  openCart();
}

function changeQty(id, delta) {
  if (!cart[id]) return;
  cart[id].qty += delta;
  if (cart[id].qty <= 0) delete cart[id];
  updateCartUI();
}

function removeItem(id) {
  delete cart[id];
  updateCartUI();
}

// ===========================
// CART DRAWER
// ===========================
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

var el_cart_btn = document.getElementById('cart-btn');
if (el_cart_btn) el_cart_btn.addEventListener('click', openCart);
var el_cart_close_btn = document.getElementById('cart-close-btn');
if (el_cart_close_btn) el_cart_close_btn.addEventListener('click', closeCart);
var el_cart_overlay = document.getElementById('cart-overlay');
if (el_cart_overlay) el_cart_overlay.addEventListener('click', closeCart);
var el_checkout_btn = document.getElementById('checkout-btn');
if (el_checkout_btn) el_checkout_btn.addEventListener('click', () => {
  showToast('💳 Redirigiendo al pago...');
  setTimeout(closeCart, 1000);
});

// ===========================
// ADD TO CART BUTTONS
// ===========================
document.querySelectorAll('.btn-add-cart').forEach(btn => {
  btn.addEventListener('click', () => {
    addToCart(btn.dataset.id, btn.dataset.name, btn.dataset.price, btn.dataset.emoji);
  });
});

// ===========================
// FILTERS
// ===========================
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const filter = btn.dataset.filter;
    document.querySelectorAll('.product-card').forEach(card => {
      card.classList.toggle('hidden', filter !== 'all' && card.dataset.category !== filter);
    });
  });
});

// ===========================
// WISHLIST
// ===========================
document.querySelectorAll('.wishlist-product-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.classList.toggle('active');
    showToast(btn.classList.contains('active') ? '❤️ Añadido a tu lista de deseos' : '💔 Eliminado de tu lista de deseos');
  });
});

// ===========================
// NAVBAR SCROLL
// ===========================
window.addEventListener('scroll', () => {
  document.body.classList.toggle('scrolled', window.scrollY > 40);
});

// ===========================
// HAMBURGER MENU
// ===========================
var el_nav_hamburger = document.getElementById('nav-hamburger');
if (el_nav_hamburger) el_nav_hamburger.addEventListener('click', () => {
  document.getElementById('nav-links').classList.toggle('open');
});

// ===========================
// COUNTDOWN TIMER
// ===========================
let endTime = Date.now() + (8 * 3600 + 34 * 60) * 1000;
function updateCountdown() {
  const cdHours = document.getElementById('cd-hours');
  if (!cdHours) return;
  const diff = Math.max(0, endTime - Date.now());
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  cdHours.textContent = String(h).padStart(2, '0');
  document.getElementById('cd-minutes').textContent = String(m).padStart(2, '0');
  document.getElementById('cd-seconds').textContent = String(s).padStart(2, '0');
}
setInterval(updateCountdown, 1000);
updateCountdown();

// ===========================
// NEWSLETTER
// ===========================
var el_newsletter_form = document.getElementById('newsletter-form');
if (el_newsletter_form) el_newsletter_form.addEventListener('submit', e => {
  e.preventDefault();
  showToast('🎉 ¡Bienvenida! Revisa tu email para tu código de descuento del 10%');
  document.getElementById('newsletter-email').value = '';
});

// ===========================
// SEARCH BTN
// ===========================
var el_search_btn = document.getElementById('search-btn');
if (el_search_btn) el_search_btn.addEventListener('click', () => {
  showToast('🔍 Función de búsqueda disponible pronto');
});
var el_wishlist_btn = document.getElementById('wishlist-btn');
if (el_wishlist_btn) el_wishlist_btn.addEventListener('click', () => {
  showToast('❤️ Tu lista de deseos está vacía');
});
  
// ===========================
// DYNAMIC HEADER VARS
// ===========================
function updateHeaderVars() {
  const annBar = document.querySelector('.section-announcement-bar');
  if (annBar) {
    document.documentElement.style.setProperty('--announcement-bar-height', `${annBar.offsetHeight}px`);
  }
}
window.addEventListener('resize', updateHeaderVars);
window.addEventListener('load', updateHeaderVars);
updateHeaderVars();

// ===========================
// LIGHTBOX (IMAGE ZOOM) LOGIC
// ===========================
let lightboxImages = [];
let currentLightboxIndex = 0;

function openLightbox(index) {
  const lightbox = document.getElementById('product-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  if (lightbox && lightboxImg && lightboxImages.length > 0) {
    currentLightboxIndex = index;
    const imgSrc = lightboxImages[currentLightboxIndex];
    const highResSrc = imgSrc.replace(/width=\d+/, 'width=2000');
    
    if (lightbox.classList.contains('active')) {
      lightboxImg.style.opacity = 0;
      setTimeout(() => {
        lightboxImg.src = highResSrc;
        lightboxImg.style.opacity = 1;
      }, 150);
    } else {
      lightboxImg.src = highResSrc;
      lightboxImg.style.opacity = 1;
      lightbox.style.display = 'flex';
      setTimeout(() => {
        lightbox.classList.add('active');
      }, 10);
    }
  }
}

function closeLightbox(e) {
  const lightbox = document.getElementById('product-lightbox');
  if (lightbox) {
    lightbox.classList.remove('active');
    setTimeout(() => {
      lightbox.style.display = 'none';
      document.getElementById('lightbox-img').src = '';
    }, 300);
  }
}

function lightboxNext() {
  if (lightboxImages.length === 0) return;
  let nextIndex = currentLightboxIndex + 1;
  if (nextIndex >= lightboxImages.length) nextIndex = 0;
  openLightbox(nextIndex);
}

function lightboxPrev() {
  if (lightboxImages.length === 0) return;
  let prevIndex = currentLightboxIndex - 1;
  if (prevIndex < 0) prevIndex = lightboxImages.length - 1;
  openLightbox(prevIndex);
}

document.addEventListener('DOMContentLoaded', function() {
  const mainImages = document.querySelectorAll('.product-media-item.zoom-cursor img');
  
  lightboxImages = Array.from(mainImages).map(img => img.src);
  
  mainImages.forEach((img, index) => {
    img.addEventListener('click', function() {
      openLightbox(index);
    });
  });

  document.addEventListener('keydown', (e) => {
    const lightbox = document.getElementById('product-lightbox');
    if (lightbox && lightbox.classList.contains('active')) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') lightboxNext();
      if (e.key === 'ArrowLeft') lightboxPrev();
    }
  });
});
